import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehiclemanager-landing-page',
  templateUrl: './vehiclemanager-landing-page.component.html',
  styleUrls: ['./vehiclemanager-landing-page.component.scss']
})
export class VehiclemanagerLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
